import styled from 'styled-components/macro';
import * as HoverCardPrimitive from '@radix-ui/react-hover-card';

export const HoverCardTrigger = styled(HoverCardPrimitive.Trigger)`
  background: unset;
  border: unset;
  padding: unset;
`;
